import React, { useState, useEffect } from 'react';

function SubscribeLoader({ endpoint, placeholder, success, error }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return <div>Loading...</div>;
  }

  const Subscribe = React.lazy(() => import('../shared/Subscribe/Subscribe.jsx'));

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Subscribe
        endpoint={endpoint}
        placeholder={placeholder}
        success={success}
        error={error}
      />
    </React.Suspense>
  );
}

export default SubscribeLoader;